import {graphql} from '@apollo/client/react/hoc';
import getStepType from 'core/libs/getStepType';
import decodeId from 'core/libs/helpers/decodeId';
import log from 'core/libs/logger';
import STEP from '../graphql/step.graphql';

const withStep = graphql(STEP, {
  alias: 'withStep',
  skip: ({stepSlug, authenticated}) => !stepSlug || !authenticated,
  options: ({stepSlug}) => ({
    variables: {
      slug: stepSlug,
    },
  }),
  props: ({data, ownProps}) => {
    const {error, loading, refetch, steps} = data;
    const {stepSlug} = ownProps;
    if (loading) return {loading};
    if (error) return {error};

    if (steps && steps.edges && !steps.edges[0]) {
      log("Didn't find a step for this slug", {
        stepSlug,
        currentUrl: typeof window !== 'undefined' && window.location.href,
      });
      return {error: "Didn't find a step for this slug"};
    }

    const step = steps && steps.edges && steps.edges[0] && steps.edges[0].node;
    const refetchStep = (slug = stepSlug) =>
      refetch({
        variables: {
          slug,
        },
      });

    return {
      loading: false,
      refetchStep,
      type: getStepType(step),
      step: {
        ...step,
        id: decodeId(step.id),
        stage: {
          id: decodeId(step.stage.id),
        },
      },
    };
  },
});

export default withStep;
